import goldLogo from "../assets/images/apps/hw-gold-price-sync.webp";
import shortcodeLogo from "../assets/images/apps/instant-shortcode-builder.webp";
import currencyLogo from "../assets/images/apps/hw-currency-convertor.png";

// Huptech app suite - single source of truth for the "Recommended apps" section
// (bottom of the Analytics dashboard) and the App Suite page, so both stay in sync.
// Logos are imported (not string paths) so webpack emits the correct URLs.

export const OTHER_APPS = [
    {
        id: "hw-gold-price-sync",
        name: "HW Gold Price Sync",
        description: "Auto-update product prices to match live gold rates and product specifics daily.",
        url: "https://apps.shopify.com/hw-gold-price-sync",
        builtForShopify: false,
        short: "Au",
        accent: "#1a1a1a",
        logo: goldLogo,
    },
    {
        id: "instant-shortcode-builder",
        name: "Instant Shortcode Builder",
        description: "Instant Shortcode helps integrate product features literally in the middle of your blog — no coding.",
        url: "https://apps.shopify.com/shortcode-app",
        builtForShopify: false,
        short: "{ }",
        accent: "#1a1a1a",
        logo: shortcodeLogo,
    },
];

export const CURRENT_APP = {
    id: "hw-currency-converter",
    name: "HW Currency Converter",
    description: "Show prices in your shoppers' local currencies and grow international sales.",
    builtForShopify: false,
    short: "$",
    accent: "#2b0e49",
    installed: true,
    logo: currencyLogo,
};
